// Kurum kalite ekranları: şikayetler, memnuniyet (B17–B18): yönlendirmeler (izin + bayrak korumalı, tembel yüklenir).
import { Route } from 'react-router';
import { guard, load } from '../../control/route-utils';

const Complaints = load(() => import('./Complaints'), 'Complaints');
const ComplaintPage = load(() => import('./Complaints'), 'ComplaintPage');
const Satisfaction = load(() => import('./Satisfaction'), 'Satisfaction');

export const businessQualityRoutes = (
  <>
    <Route path="sikayetler" element={guard(Complaints, 'quality')} />
    <Route path="sikayetler/:id" element={guard(ComplaintPage, 'quality')} />
    <Route path="memnuniyet" element={guard(Satisfaction, 'quality')} />
  </>
);
